<div class="TimeDisplayMenuComponent">
    <span class="popover-title">Customize your time display</span>

    <div class="selections">
        <ng-container *ngFor="let timeDisplay of timeObservables$ | async">
            <div
                class="item"
                [ngClass]="{ selected: timeDisplay.type === (timeObservable$ | async).type }"
                (click)="selectOption(timeDisplay)"
                (keydown.enter)="selectOption(timeDisplay)"
            >
                <mat-icon *ngIf="timeDisplay.icon" class="icon" svgIcon="{{ timeDisplay.icon }}"></mat-icon>
                <span class="label"> {{ timeDisplay.label }} {{ timeDisplay.utcLabel }} </span>
            </div>
        </ng-container>
    </div>
</div>
